export const FRAUDSTER_TOOL_SMS = 'SMS';
export const FRAUDSTER_TOOL_KYC = 'KYC';



// WEBPACK FOOTER //
// ./src/constants/fraud.js